import { render, staticRenderFns } from "./TechnicalInspectionReportsView.vue?vue&type=template&id=6974822c"
import script from "./TechnicalInspectionReportsView.vue?vue&type=script&lang=js"
export * from "./TechnicalInspectionReportsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports